// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import config from '../../config/config';

// Define a service using a base URL and expected endpoints
export const successionPlanDocsListAPI = createApi({
  reducerPath: 'successionPlanDocsListAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ['Docs'],
  endpoints: (builder) => ({
    getSuccessionPlanDocsList: builder.query<any, UserSpecificArgTypes>({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/successions`,
        method: 'GET',
      }),
      providesTags: ['Docs'],
    }),
    deleteSuccessionPlanDocsItem: builder.mutation<any, ABOSuccessionIdType>({
      query: ({ id }) => ({
        url: `/am/abo/succession/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Docs'],
    }),
    uploadSuccessionPlan: builder.mutation<any, UploadSuccessionArgTypes>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/succession`,
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: ['Docs'],
    }),
    updateSuccessionPlan: builder.mutation<any, UploadSuccessionArgTypes>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/succession/update`,
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: ['Docs'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSuccessionPlanDocsListQuery,
  useDeleteSuccessionPlanDocsItemMutation,
  useUploadSuccessionPlanMutation,
  useUpdateSuccessionPlanMutation,
} = successionPlanDocsListAPI;
